import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDescending = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.16669 3.14844L5.19632 7.11881C5.17055 7.14461 5.13995 7.16508 5.10627 7.17904C5.07259 7.19301 5.03648 7.2002 5.00002 7.2002C4.96356 7.2002 4.92745 7.19301 4.89377 7.17904C4.86009 7.16508 4.82949 7.14461 4.80372 7.11881L0.833353 3.14844",
		stroke: "#006ADC",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgDescending);
export default ForwardRef;
